export const DEFAULT_PAGE_TITLE =
	" Airen | Airen - Loyalty by Octopi Labs";
export const DEFAULT_PAGE_DESCRIPTION =
	"Airen | Airen - Loyalty by Octopi Labs - https://octopi-labs.com";
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const SCRAPING_API_BASE_URL = "http://localhost:8080"; // Scraping service backend
	
// ====== APPLICATION CONSTANTS ====== //
export const API_URL = process.env.REACT_APP_API_BASE_URL;
// export const API_URL = "http://192.168.1.246:8081";//"http://localhost:8081";//"http://192.168.1.14:8081";//
export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const SYSTEM_TOKEN = process.env.REACT_APP_SYSTEM_TOKEN;
export const DEFAULT_PER_PAGE = 12;

export const ELIGIBLE_FOR_COMMISSION_OPTIONS = [
	{ label: "YES", value: 1 },
	{ label: "NO", value: 0 },
	
];


